import { render, staticRenderFns } from "./readBook.vue?vue&type=template&id=fa428aca"
import script from "./readBook.vue?vue&type=script&setup=true&lang=js"
export * from "./readBook.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports